import { css } from 'linaria';

export const buttonStyle = css`
  position: absolute;
  top: 50%;

  z-index: 2;
  margin-right: 0;
  --button-bg: var(--background-primary);
  --translate-distance: 0 !important;
  background-color: var(--background-primary);
  width: var(--space-600);
  height: var(--space-600);
  border-radius: var(--space-600);
  box-shadow: var(--box-shadow-m);
  &:active {
    background-color: var(--background-primary);
  }
  &:focus {
    background-color: var(--background-primary);
  }
  &:hover {
    background-color: var(--background-primary);
  }
  span {
    position: absolute;
  }
  &.left {
    left: 0;
    transform: translateY(-50%) translateX(-100%);
    span {
      left: -1px;
    }
  }
  &.right {
    right: 0;
    transform: translateY(-50%) translateX(100%);
    span {
      right: -1px;
    }
  }
`;
